const DefaultPriceBand = {
  type: 'DefaultPriceBand',
  dropdown: {
    valueKey: 'value',
    labelKey: 'label',
    isEnum: true,
  },
};

export default DefaultPriceBand;
